
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { nhapKhoApi } from '../../../api/category/nhapKhoApi';
import { INhapKho } from '../../../model/respone/category/INhapKho';
import { IBaseRespone } from '../../../model/respone/IBaseRespone';
import { eNhapKhoActionTypeIds, INhapKhoActions } from "../../action-types/category/INhapKhoActionTypes";
import { rootActions } from '../../actions/rootActions';
import { INhapKhoDelete } from "../../../model/request/category/INhapKhoDelete";
import { INhapKhoImportRequest } from "../../../model/request/category/INhapKhoImportRequest";
import { IXuatKhoRequest } from "../../../model/request/category/IXuatKhoRequest";
import { IXuatKhoBatchRequest } from "../../../model/request/category/IXuatKhoBatchRequest";
const mainAction = rootActions.category.nhapKho;
export function* nhapKhoSaga(): any {
    yield takeLatest(eNhapKhoActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eNhapKhoActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eNhapKhoActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eNhapKhoActionTypeIds.SAVE_IMPORT_START, saveImportWorker)
    yield takeEvery(eNhapKhoActionTypeIds.XUAT_KHO_START, xuatKhoWorker)
    yield takeEvery(eNhapKhoActionTypeIds.XUAT_KHO_BATCH_START, xuatKhoBatchWorker)
}

function* loadWorker(action: INhapKhoActions): any {
    const res: IBaseRespone = yield call(nhapKhoApi.SelectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveWorker(action: INhapKhoActions): any {
    let res: IBaseRespone;
    const Kho = action.payload as INhapKho;
    if (Kho.id > 0) {
        res = yield call(nhapKhoApi.Update, Kho)
    } else {
        res = yield call(nhapKhoApi.Insert, Kho)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* deleteWorker(action: INhapKhoActions): any {
    const res: IBaseRespone = yield call(nhapKhoApi.Delete, action.payload as INhapKhoDelete)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data))
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"))
    }
}

function* saveImportWorker(action: INhapKhoActions): any {
    const res: IBaseRespone = yield call(nhapKhoApi.SaveDataExcel, action.payload as INhapKhoImportRequest)
    if (res.is_success) {
        yield put(mainAction.SAVE_IMPORT_SUCCESS(res.data))
    } else {
        yield put(mainAction.SAVE_IMPORT_ERROR(res.message ?? "Có lỗi"))
    }
}

function* xuatKhoWorker(action: INhapKhoActions): any {
    const payload = action.payload as IXuatKhoRequest;
    const res: IBaseRespone = yield call(nhapKhoApi.XuatKho, payload);
    if (res.is_success) {
        yield put(mainAction.XUAT_KHO_SUCCESS(undefined));
    } else {
        yield put(mainAction.XUAT_KHO_ERROR(res.message ?? "Có lỗi"));
    }
}

function* xuatKhoBatchWorker(action: INhapKhoActions): any {
    const payload = action.payload as IXuatKhoBatchRequest;
    const res: IBaseRespone = yield call(nhapKhoApi.XuatKhoBatch, payload);
    if (res.is_success) {
        yield put(mainAction.XUAT_KHO_BATCH_SUCCESS(undefined));
        // Reload data sau khi xuất kho thành công
        yield put(mainAction.LOAD_START(undefined));
    } else {
        yield put(mainAction.XUAT_KHO_BATCH_ERROR(res.message ?? "Có lỗi"));
    }
}